import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface SkipLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}

const SkipLink = React.forwardRef<HTMLAnchorElement, SkipLinkProps>(
  ({ href, children, className }, ref) => {
    return (
      <a
        ref={ref}
        href={href}
        className={cn(
          "sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50",
          "bg-primary text-primary-foreground px-4 py-2 rounded-md font-medium",
          "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
          "transition-transform focus:animate-in focus:fade-in focus:slide-in-from-top-2",
          className
        )}
      >
        {children}
      </a>
    );
  }
);

SkipLink.displayName = 'SkipLink';

export const SkipLinks = () => {
  const { t } = useTranslation();
  const [hasNav, setHasNav] = useState(false);

  useEffect(() => {
    // Check after a tick to allow DOM to render
    const timer = setTimeout(() => {
      setHasNav(!!document.getElementById('navigation'));
    }, 0);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <SkipLink href="#main-content">
        {t('accessibility.skipToMain', 'Aller au contenu principal')}
      </SkipLink>
      {hasNav && (
        <SkipLink href="#navigation" className="focus:top-14">
          {t('accessibility.skipToNav', 'Aller à la navigation')}
        </SkipLink>
      )}
    </>
  );
};
